export default __webpack_public_path__ + "static/media/Mont-Bold.03c8c2f6.otf";